/* eslint-disable react/forbid-prop-types */
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { TextareaInput } from 'components/FormControl';

function RejectModal({
  visible,
  onClose,
  onSubmit,
  handleSubmit,
  control,
  errors,
  data,
  isSubmitting,
}) {
  const { t } = useTranslation();

  return (
    <Dialog
      header={<p className="text-blue-500">{t('projectAdjustment.rejectModal.title')}</p>}
      visible={visible}
      position="center"
      style={{ width: '600px' }}
      onHide={onClose}
      draggable={false}
    >
      <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
        <TextareaInput
          name="rejectionReason"
          label={t('projectAdjustment.rejectModal.reason')}
          control={control}
          errors={errors}
          row={6}
          isRequired
          defaultValue={data?.comment}
        />
        <div className="flex justify-content-end gap-2 mt-4">
          <Button
            type="button"
            label={t('employee.cancel')}
            className="w-7rem"
            severity="danger"
            onClick={onClose}
            autoFocus
          />
          <Button
            label={t('employee.ok')}
            className="w-7rem"
            severity="info"
            type="submit"
            disabled={isSubmitting}
          />
        </div>
      </form>
    </Dialog>
  );
}

RejectModal.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  handleSubmit: PropTypes.func,
  control: PropTypes.object,
  errors: PropTypes.object,
  data: PropTypes.object,
  isSubmitting: PropTypes.bool,
};

RejectModal.defaultProps = {
  visible: false,
  onClose: () => {},
  onSubmit: () => {},
  handleSubmit: () => {},
  control: {},
  errors: {},
  data: {},
  isSubmitting: false,
};

export default RejectModal;
